import { set } from 'idb-keyval'
import fetch from 'map-data-fetch'

export const fetchAndStoreData = async (dataId) => {
  const geojson = await fetch(`public/${dataId}`, 'geojson')
  await set(dataId, geojson)
  return geojson
}
